var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploadDisbled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4999 11.0417L25.6514 10.1932L26.4999 9.34469L27.3484 10.1932L26.4999 11.0417ZM27.6999 30.9167C27.6999 31.5795 27.1627 32.1167 26.4999 32.1167C25.8372 32.1167 25.2999 31.5795 25.2999 30.9167L27.6999 30.9167ZM14.6097 21.2349L25.6514 10.1932L27.3484 11.8903L16.3068 22.9319L14.6097 21.2349ZM27.3484 10.1932L38.3901 21.2349L36.6931 22.9319L25.6514 11.8903L27.3484 10.1932ZM27.6999 11.0417L27.6999 30.9167L25.2999 30.9167L25.2999 11.0417L27.6999 11.0417Z",
    fill: "#9CA7AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0417 35.3333L11.0417 37.5416C11.0417 39.9808 13.0192 41.9583 15.4584 41.9583L37.5417 41.9583C39.981 41.9583 41.9584 39.9808 41.9584 37.5416V35.3333",
    stroke: "#9CA7AF",
    strokeWidth: 2.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0417,
    y: 33.125,
    width: 30.9167,
    height: 8.83333,
    rx: 2,
    fill: "#7E869E",
    fillOpacity: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadDisbled);
export default __webpack_public_path__ + "static/media/fileUploadDisbled.8a8d123a2587630bb5a90cfcf6ae92ec.svg";
export { ForwardRef as ReactComponent };